// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
// import { models } from '../../utils';
import { setError } from '../error/actions';
import { getQuestion } from '../questions/actions';

// export function voteAnswer(answerId: number, questionId: number) {
//   return (dispatch: Dispatch) => {
//     dispatch(optimisticVoteAnswer(answerId, questionId, true));
//     finectAPI({
//       version: 'v3',
//       path: `questions/${questionId}/answers/${answerId}/vote`,
//       method: 'POST',
//       onSuccess: (question: Object) => {
//         const modelizedQuestion = models.questions(question);
//         dispatch(setQuestion(modelizedQuestion));
//       },
//       onError: error => dispatch(setError(error))
//     });
//   };
// }

// export function unvoteAnswer(answerId: number, questionId: number) {
//   return (dispatch: Dispatch) => {
//     dispatch(optimisticVoteAnswer(answerId, questionId, false));
//     finectAPI({
//       version: 'v3',
//       path: `questions/${questionId}/answers/${answerId}/unvote`,
//       method: 'POST',
//       onSuccess: (question: Object) => {
//         const modelizedQuestion = models.questions(question);
//         dispatch(setQuestion(modelizedQuestion));
//       },
//       onError: error => dispatch(setError(error))
//     });
//   };
// }

export function selectAnswer(answerId: number, questionId: number) {
  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers/${answerId}/select`,
      method: 'POST',
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(getQuestion(modelizedQuestion));
        dispatch(getQuestion(questionId));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

export function sendAnswer(answer: Object, questionId: number) {
  const newAnswer = {
    body: JSON.stringify(answer.rawContent),
    plain_text: answer.plainText, // eslint-disable-line
    products: answer.products
  };

  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers`,
      method: 'POST',
      body: newAnswer,
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
        dispatch(getQuestion(questionId));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

export function editAnswer(answer: Object, questionId: number) {
  const editedAnswer = {
    body: JSON.stringify(answer.rawContent),
    plain_text: answer.plainText, // eslint-disable-line
    products: answer.products
  };

  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers/${answer.id}`,
      method: 'PUT',
      body: editedAnswer,
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
        dispatch(getQuestion(questionId));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

export function deleteAnswer(answerId: number, questionId: number) {
  return (dispatch: Dispatch) => {
    finectAPI({
      version: 'v3',
      path: `questions/${questionId}/answers/${answerId}`,
      method: 'DELETE',
      onSuccess: (question: Object) => {
        // const modelizedQuestion = models.questions(question);
        // dispatch(setQuestion(modelizedQuestion));
        dispatch(getQuestion(questionId));
      },
      onError: error => dispatch(setError(error))
    });
  };
}

/*
export function reportAnswer(answerId: number, report: Object) {}
*/
